import axios from 'axios';

export default{

  //未来15天能耗 
  load(data) {
    return axios.get('/pro/load/list',data);
  },
  //单位产品能耗趋势 
  tendency(data) {
    return axios.get('/pro/energy/list',data);
  },
  //获取新装设备
  getNewDev() {
    return axios.get('/dev/fresh/list2');
  },
} 